// DeeDee AI Try-On Widget v2
// Features: Guide screen, login gate popup, best photo selection, mobile fix

(function() {
  const WEBHOOK_URL = 'https://tryon.srv1130341.hstgr.cloud/api/tryon';
  const MAX_TRIES = 3;
  const GUIDE_IMAGE_URL = 'https://cdn.shopify.com/s/files/1/0790/8855/0219/files/logo_fijnemode_500_x_400_px_2.png?v=1775233555';

  let cachedVariantImageUrl = null;

  function fixProtocol(url) {
    if (!url) return null;
    if (url.startsWith('//')) return 'https:' + url;
    return url;
  }

  function getActiveImageFromDOM() {
    const activeSlide = document.querySelector('.product__media-item.slider__slide.is-active');
    if (activeSlide) {
      const img = activeSlide.querySelector('img');
      if (img?.src) return img.src;
    }
    const anyActiveSlide = document.querySelector('.slider__slide.is-active');
    if (anyActiveSlide) {
      const img = anyActiveSlide.querySelector('img');
      if (img?.src) return img.src;
    }
    const mediaImages = document.querySelectorAll('.product__media-item img');
    for (const img of mediaImages) {
      if (img.src && !img.src.includes('placeholder')) return img.src;
    }
    return (
      document.querySelector('.product__media img')?.src ||
      document.querySelector('[data-media-type="image"] img')?.src ||
      null
    );
  }

  function startImageObserver() {
    const mediaContainer =
      document.querySelector('.product__media-wrapper') ||
      document.querySelector('.product__media-list') ||
      document.querySelector('.product__media') ||
      document.querySelector('[data-media-type="image"]')?.parentElement;
    if (!mediaContainer) return;
    const observer = new MutationObserver(() => {
      const newImage = getActiveImageFromDOM();
      if (newImage && newImage !== cachedVariantImageUrl) {
        cachedVariantImageUrl = fixProtocol(newImage);
      }
    });
    observer.observe(mediaContainer, { subtree: true, attributes: true, attributeFilter: ['src', 'srcset', 'class'] });
  }

  document.addEventListener('click', (e) => {
    const isYmqSwatch = (
      e.target.closest('[class*="ymq-option"]') ||
      e.target.closest('.ymq-option-swatches-input') ||
      e.target.closest('.ymq-option-swatches-item')
    );
    if (isYmqSwatch) {
      setTimeout(() => { const img = getActiveImageFromDOM(); if (img) cachedVariantImageUrl = fixProtocol(img); }, 500);
      setTimeout(() => { const img = getActiveImageFromDOM(); if (img) cachedVariantImageUrl = fixProtocol(img); }, 1200);
    }
  });

  document.addEventListener('variant:change', (e) => {
    const variant = e.detail?.variant;
    if (variant?.featured_image?.src) cachedVariantImageUrl = fixProtocol(variant.featured_image.src);
  });

  document.addEventListener('variantChange', (e) => {
    const variant = e.detail?.variant;
    if (variant?.featured_image?.src) cachedVariantImageUrl = fixProtocol(variant.featured_image.src);
  });

  function getVariantImageUrl() {
    if (cachedVariantImageUrl) return cachedVariantImageUrl;
    return fixProtocol(getActiveImageFromDOM());
  }

  function getVariantOptions() {
    const options = { lace_size: '', hair_color: '', hair_length: '' };
    const formInputs = document.querySelectorAll('.product-form__input');
    formInputs.forEach(container => {
      const label = container.querySelector('legend, label')?.textContent?.trim().toLowerCase() || '';
      let value = '';
      const checkedRadio = container.querySelector('input[type="radio"]:checked');
      const select = container.querySelector('select');
      if (checkedRadio) value = checkedRadio.value || checkedRadio.dataset?.value || '';
      else if (select) value = select.value;
      if (label.includes('lace size') || label === 'lace size') options.lace_size = value;
      else if (label.includes('hair color') || label === 'hair color' || label.includes('color')) options.hair_color = value;
      else if (label.includes('hair length') || label === 'hair length' || label.includes('length')) options.hair_length = value;
    });
    if (!options.lace_size && !options.hair_color && !options.hair_length) {
      const selects = document.querySelectorAll('select[name^="option"], select[id^="Option"]');
      selects.forEach((select, index) => {
        const value = select.value;
        const label = (select.getAttribute('aria-label') || select.closest('.product-form__input')?.querySelector('label')?.textContent || select.name || '').toLowerCase();
        if (label.includes('lace') || index === 0) options.lace_size = value;
        else if (label.includes('color') || index === 1) options.hair_color = value;
        else if (label.includes('length') || index === 2) options.hair_length = value;
      });
    }
    return options;
  }

  function getStorageKey(customerId) {
    const today = new Date().toISOString().split('T')[0];
    return `deedee_tryon_${customerId}_${today}`;
  }

  function getTriesRemaining(customerId) {
    const key = getStorageKey(customerId);
    const stored = localStorage.getItem(key);
    const used = stored ? parseInt(stored) : 0;
    return Math.max(0, MAX_TRIES - used);
  }

  function incrementTries(customerId) {
    const key = getStorageKey(customerId);
    const stored = localStorage.getItem(key);
    const used = stored ? parseInt(stored) : 0;
    localStorage.setItem(key, (used + 1).toString());
  }

  async function compressImage(file, maxSize = 800) {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement('canvas');
          let width = img.width;
          let height = img.height;
          if (width > height && width > maxSize) { height = (height * maxSize) / width; width = maxSize; }
          else if (height > maxSize) { width = (width * maxSize) / height; height = maxSize; }
          canvas.width = width;
          canvas.height = height;
          canvas.getContext('2d').drawImage(img, 0, 0, width, height);
          resolve(canvas.toDataURL('image/jpeg', 0.85));
        };
        img.src = e.target.result;
      };
      reader.readAsDataURL(file);
    });
  }

  function updateUploadLabel(input, label) {
    if (input.files && input.files[0]) {
      label.classList.add('has-file');
      label.querySelector('.deedee-label-text').textContent = '✓ Photo Selected';
    } else {
      label.classList.remove('has-file');
      label.querySelector('.deedee-label-text').textContent = '📷 Front View';
    }
  }

  // ── LOGIN POPUP ──────────────────────────────────────────────────────────────
  function showLoginPopup() {
    if (document.querySelector('.deedee-login-popup')) return;

    const overlay = document.createElement('div');
    overlay.className = 'deedee-login-popup';
    overlay.style.cssText = `
      position: fixed; inset: 0; z-index: 99999;
      background: rgba(0,0,0,0.7);
      display: flex; align-items: center; justify-content: center;
      padding: 20px; box-sizing: border-box;
    `;

    overlay.innerHTML = `
      <div style="
        background: #1a1a2e; border-radius: 16px; padding: 32px 24px;
        max-width: 360px; width: 100%; text-align: center;
        box-shadow: 0 20px 60px rgba(0,0,0,0.5);
        border: 1px solid rgba(255,255,255,0.1);
      ">
        <div style="font-size: 40px; margin-bottom: 12px;">✨</div>
        <h3 style="color: #fff; font-size: 20px; margin: 0 0 8px; font-weight: 600;">Try This Wig On Yourself</h3>
        <p style="color: rgba(255,255,255,0.7); font-size: 14px; margin: 0 0 24px; line-height: 1.5;">
          Log in to your account to use the AI try-on feature. It only takes a second.
        </p>
        <a href="/account/login?return_url=${encodeURIComponent(window.location.pathname)}" style="
          display: block; background: linear-gradient(135deg, #6b4fbb, #8b5cf6);
          color: #fff; text-decoration: none; padding: 14px 24px;
          border-radius: 10px; font-size: 15px; font-weight: 600;
          margin-bottom: 12px; transition: opacity 0.2s;
        " onmouseover="this.style.opacity='0.9'" onmouseout="this.style.opacity='1'">
          Log In to Continue
        </a>
        <a href="/account/register" style="
          display: block; color: rgba(255,255,255,0.6); text-decoration: none;
          font-size: 13px; padding: 8px;
        ">
          Don't have an account? <span style="color: #a78bfa; text-decoration: underline;">Sign up free</span>
        </a>
        <button onclick="this.closest('.deedee-login-popup').remove()" style="
          background: none; border: none; color: rgba(255,255,255,0.4);
          font-size: 12px; cursor: pointer; margin-top: 16px; padding: 4px 8px;
        ">✕ Close</button>
      </div>
    `;

    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) overlay.remove();
    });

    document.body.appendChild(overlay);
  }

  // ── MAIN INIT ────────────────────────────────────────────────────────────────
  function init() {
    const widget = document.querySelector('.deedee-ai-tryon-widget');
    if (!widget) return;

    const trigger = widget.querySelector('.deedee-tryon-trigger');
    const form = widget.querySelector('.deedee-tryon-form');
    const inputs = {
      photo1: widget.querySelector('#photo-upload-1')
    };
    const labels = {
      photo1: widget.querySelector('label[for="photo-upload-1"]')
    };
    const generateBtn = widget.querySelector('.deedee-generate-btn');
    const resultDiv = widget.querySelector('.deedee-result');
    const statusDiv = widget.querySelector('.deedee-status');

    let isGenerating = false;

    // ── INJECT GUIDE SCREEN inside the form, before the upload slots ──
    const uploadInstructions = widget.querySelector('.deedee-upload-instructions');
    if (uploadInstructions) {
      uploadInstructions.innerHTML = `
        <div style="text-align: center; margin-bottom: 16px;">
          <h3 style="font-size: 18px; font-weight: 700; margin: 0 0 4px; color: #fff;">See Yourself With This Style</h3>
          <p style="font-size: 13px; color: rgba(255,255,255,0.6); margin: 0 0 14px;">Upload a photo to preview the final look</p>
          <img src="${GUIDE_IMAGE_URL}" alt="Photo guide - correct vs too close"
            style="width: 100%; max-width: 340px; border-radius: 12px; display: block; margin: 0 auto 14px;"
            onerror="this.style.display='none'"
          />
          <div style="text-align: left; background: rgba(255,255,255,0.05); border-radius: 10px; padding: 12px 16px; margin-bottom: 4px;">
            <p style="font-size: 13px; font-weight: 700; color: #fff; margin: 0 0 8px;">• For best results:</p>
            <p style="font-size: 13px; color: rgba(255,255,255,0.75); margin: 0 0 4px;">– Frame from head to below the bust</p>
            <p style="font-size: 13px; color: rgba(255,255,255,0.75); margin: 0 0 4px;">– Keep your face fully visible</p>
            <p style="font-size: 13px; color: rgba(255,255,255,0.75); margin: 0 0 4px;">– Use natural lighting</p>
            <p style="font-size: 13px; color: rgba(255,255,255,0.75); margin: 0;">– Avoid close-up selfies</p>
          </div>
          <p style="font-size: 11px; color: rgba(255,255,255,0.4); margin: 10px 0 4px; font-style: italic;">
            Your photo is used only for preview and <strong style="color: rgba(255,255,255,0.6);">never shared</strong>.
          </p>
          <p style="font-size: 11px; color: rgba(255,255,255,0.3); margin: 0 0 0; font-style: italic;">
            AI preview is not always 100% accurate and may differ from the final result.
          </p>
        </div>
      `;
    }

    // ── REMOVE old disclaimer (now replaced by guide) ──
    const oldDisclaimer = document.querySelector('.deedee-skin-tone-disclaimer');
    if (oldDisclaimer) oldDisclaimer.remove();

    // ── TOGGLE ──
    if (trigger) {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        const isExpanded = form.style.display === 'block';
        form.style.display = isExpanded ? 'none' : 'block';
        trigger.querySelector('.deedee-arrow')?.classList.toggle('expanded');
      });
    }

    // ── OBSERVER ──
    setTimeout(() => {
      startImageObserver();
      if (!cachedVariantImageUrl) {
        const domImage = getActiveImageFromDOM();
        if (domImage) cachedVariantImageUrl = fixProtocol(domImage);
      }
    }, 1000);

    // ── BUTTON STATE ──
    function updateButtonState() {
      const hasAllPhotos = inputs.photo1.files[0];
      generateBtn.disabled = !hasAllPhotos || isGenerating;
    }

    // ── FILE INPUTS ──
    Object.keys(inputs).forEach(key => {
      const input = inputs[key];
      const label = labels[key];
      if (input && label) {
        input.addEventListener('change', () => {
          updateUploadLabel(input, label);
          updateButtonState();
        });
      }
    });

    // ── UPLOAD LABEL CLICKS — check login first ──
    Object.keys(labels).forEach(key => {
      const label = labels[key];
      const input = inputs[key];
      if (label && input) {
        label.addEventListener('click', (e) => {
          const customerId = window.ShopifyAnalytics?.meta?.page?.customerId;
          if (!customerId) {
            e.preventDefault();
            showLoginPopup();
          }
        });
      }
    });

    // ── GENERATE ──
    if (generateBtn) {
      generateBtn.addEventListener('click', async () => {
        if (isGenerating) return;

        const customerId = window.ShopifyAnalytics?.meta?.page?.customerId;
        if (!customerId) {
          showLoginPopup();
          return;
        }

        const triesRemaining = getTriesRemaining(customerId);
        if (triesRemaining <= 0) {
          alert('You have reached your daily limit of 3 try-ons. Please try again tomorrow!');
          return;
        }

        if (!inputs.photo1.files[0]) {
          alert('Please upload your photo');
          return;
        }

        isGenerating = true;
        generateBtn.disabled = true;
        resultDiv.innerHTML = '';
        statusDiv.innerHTML = '<div class="deedee-loading">✨ Generating your try-on... (30-60 seconds)</div>';

        try {
          const variantOptions = getVariantOptions();
          const wigImageUrl = getVariantImageUrl();

          if (!wigImageUrl) {
            throw new Error('Could not detect wig image. Please select a color and try again.');
          }

          statusDiv.innerHTML = '<div class="deedee-loading">📸 Preparing photos...</div>';

          const bestPhoto = await compressImage(inputs.photo1.files[0]);

          const payload = {
            action: 'generate_tryon',
            customer_id: customerId.toString(),
            customer_email: window.ShopifyAnalytics?.meta?.page?.customerEmail || '',
            product_title: document.querySelector('.product__title')?.textContent?.trim() || '',
            product_id: window.ShopifyAnalytics?.meta?.product?.id?.toString() || '',
            variant_id: window.ShopifyAnalytics?.meta?.selectedVariantId?.toString() || '',
            photo_1: bestPhoto,
            photo_2: bestPhoto,
            photo_3: bestPhoto,
            selected_variant_image_url: wigImageUrl,
            variant_options: variantOptions,
            date: new Date().toISOString().split('T')[0],
            timestamp: new Date().toISOString()
          };

          statusDiv.innerHTML = '<div class="deedee-loading">✨ Generating your try-on...</div>';
          let countdown = 60;
          const countdownInterval = setInterval(() => {
            countdown--;
            if (countdown > 0) {
              statusDiv.innerHTML = `<div class="deedee-loading">✨ Generating... (~${countdown}s remaining)</div>`;
            }
          }, 1000);

          const response = await fetch(WEBHOOK_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
          });

          clearInterval(countdownInterval);

          if (!response.ok) {
            const errorText = await response.text();
            throw new Error(`Server error: ${response.status}`);
          }

          const result = await response.json();

          if (!result.success) {
            throw new Error(result.error || 'Generation failed');
          }

          incrementTries(customerId);
          const newTriesRemaining = getTriesRemaining(customerId);
          statusDiv.innerHTML = `<div class="deedee-success">✅ Generated! (${newTriesRemaining} tries left today)</div>`;
          resultDiv.innerHTML = `
            <img src="${result.generated_image_url}" alt="AI Try-On Result" class="deedee-result-image">
            <a href="${result.generated_image_url}" download="deedee-tryon.jpg" class="deedee-download-btn">
              📥 Download Image
            </a>
            <button class="deedee-try-again-btn">🔄 Try Again</button>
          `;

          resultDiv.querySelector('.deedee-try-again-btn')?.addEventListener('click', () => {
            resultDiv.innerHTML = '';
            statusDiv.innerHTML = '';
            inputs.photo1.value = '';
            updateUploadLabel(inputs.photo1, labels.photo1);
            updateButtonState();
          });

        } catch (error) {
          console.error('❌ Error:', error);
          statusDiv.innerHTML = `<div class="deedee-error">❌ ${error.message}</div>`;
        } finally {
          isGenerating = false;
          updateButtonState();
        }
      });
    }

    console.log('✅ DeeDee AI Try-On Widget v2 initialized');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();